
import React, { forwardRef, Component } from 'react';
import  {withStyles}  from '@material-ui/core';
import HeighComponent from './HeightComponent'

const useStyles = withStyles(theme => ({
    typography: {
        padding: theme.spacing(2),
    },
    avatar: {
        margin: 10,
        borderRadius: 'unset',
        width: 50,
        height: 'auto',
        cursor: 'pointer'
    },
    active: {
        border: '1px solid #2b2b2b',
        padding: '5px'
    }
}));



export const HeightDropDown = (props) => {
    return (
        <HeighComponent {...props} />
    );
}
